<template>
<v-autocomplete :loading="loading" clearable :value="value" :items="items" item-text="title" item-value="_id" label="هزینه" :rules="requiredRules" @input="v => $emit('input', v)" no-data-text="اطلاعاتی موجود نیست..."
  prepend-inner-icon="mdi-cash-minus" />
</template>

<script>
//
import myAxios from '../functions/myAxios'

export default {
  name: 'MyCosts',
  props: {
    value: {
      // type: String,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      items: [],
      requiredRules: [
        v => !!v || 'فیلد اجباری',
      ],
    }
  },
  methods: {
    async retrieveData() {
      //
      this.loading = true
      try {
        let res = await myAxios({
          method: 'GET',
          url: `/api/costs/name`,
        });
        // console.log(res.data);
        if (res && res.data) {
          let title = res.data.map(function(item) {
            return {
              _id: item._id,
              title: `${item.id}-${item.title}`
              // title: item.title
            }
          })
          this.items = title
          this.loading = false
        }
      } catch (e) {
        console.error(e)
      }
    },
  },
  async created() {
    await this.retrieveData()
  },
}
</script>
